import React from "react";
import { Icon } from "antd";

const TakeOffSvg: React.FC = () => (
  <svg width="1em" height="1em" viewBox="0 0 512 512">
    <g>
      <path
        d="M464.917,64c-5.396,0-10.667,0.906-15.667,2.677L107.542,187.281c-6.292,2.208-13.375,1.344-18.938-2.365l-50.688-33.792
				c-4.25-2.844-9.854-2.26-13.458,1.333L3.125,173.792c-3.75,3.75-4.167,9.698-1,13.938l64,85.333
				c2.667,3.521,7.208,5.083,11.396,3.885l173.208-48.115l-36.917,120.031c-1.188,3.813-0.125,7.969,2.729,10.76
				c2.021,1.979,4.708,3.042,7.458,3.042c1.125,0,2.271-0.177,3.375-0.552l64-21.333c2.479-0.823,4.583-2.542,5.896-4.823
        l83.292-145.792l99.229-33.083c19.271-6.417,32.208-24.365,32.208-45.99C512,85.125,490.875,64,464.917,64z"
        fill="currentColor"
      />
      <path
        d="M352,405.333H10.667C4.771,405.333,0,410.104,0,416v21.333C0,443.229,4.771,448,10.667,448H352
        c5.896,0,10.667-4.771,10.667-10.667V416C362.667,410.104,357.896,405.333,352,405.333z"
        fill="currentColor"
      />
    </g>
  </svg>
);

const TakeOffIcon: React.FC = props => (
  <Icon component={TakeOffSvg} {...props}></Icon>
);

export default TakeOffIcon;
